import { useEffect } from "react";

interface SeoProps {
  title: string;
  description: string;
  jsonLd?: object[];
}

export default function Seo({ title, description, jsonLd = [] }: SeoProps) {
  useEffect(() => {
    document.title = title;

    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description);

    document.querySelectorAll("script[data-chigua-jsonld]").forEach((n) => n.remove());
    jsonLd.forEach((data) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.dataset.chiguaJsonld = "true";
      s.textContent = JSON.stringify(data);
      document.head.appendChild(s);
    });
  }, [title, description, jsonLd]);

  return null;
}